import { Component, forwardRef, Input, ElementRef, ViewChild } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { Temperature } from "shared/cubiq-services";
import { MenuItem } from "@bfx/primeng/api";
import { BfxBlotterFilterable } from "./bfx-blotter-filterable";
import { DashboardMenuItem } from "app/bfx-common/models/dashboard-menu-item";
import { SplitButton } from "@bfx/primeng/splitbutton";

export const TEMPERATURE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxBlotterFilterTemperatureComponent),
  multi: true,
};

@Component({
  selector: "bfx-blotter-filter-temperature",
  templateUrl: "./html/bfx-blotter-filter-temperature.html",
  providers: [TEMPERATURE_VALUE_ACCESSOR],
  standalone: false,
})
export class BfxBlotterFilterTemperatureComponent implements ControlValueAccessor {
  /**
   * Optional blotter instance or any implementor of blotter filterable
   */
  @Input()
  public blotterInstance: BfxBlotterFilterable = null;

  private value: Temperature = Temperature.Cold;

  private onModelChange: Function = () => {};
  private onModelTouched: Function = () => {};

  private disabled: boolean = false;

  public activeItem: string = null;
  public activeIcon: string = null;

  @ViewChild("splitOptions")
  private splitOptions: SplitButton;

  styleClasses: any = {};

  public items: Array<MenuItem> = [
    {
      label: "Cold & Up",
      icon: "fa icon-dot cold",
      command: () => {
        this.setValueInternal(Temperature.Cold);
      },
    },
    {
      label: "Warm & Up",
      icon: "fa icon-dot warm",
      command: () => {
        this.setValueInternal(Temperature.Warm);
      },
    },
    {
      label: "Hot & Up",
      icon: "fa icon-dot hot",
      command: () => {
        this.setValueInternal(Temperature.Hot);
      },
    },
    {
      label: "Triggered",
      icon: "fa icon-dot triggered",
      command: () => {
        this.setValueInternal(Temperature.Triggered);
      },
    },
  ];

  constructor(private button: ElementRef) {
    this.updateStyleClasses();
  }

  /**
   * Initialize value from blotter configuration in case this component is attached to
   * blotter filter bar.
   */
  ngOnInit() {
    if (this.blotterInstance != null) {
      this.value = this.blotterInstance.getTemperatureSetting();
    }
  }

  protected updateActiveItem() {
    this.activeItem = this.items[this.value].label;
    this.activeIcon = this.items[this.value].icon;
  }

  protected updateStyleClasses(): void {
    this.updateActiveItem();
    this.items.forEach(
      (item: MenuItem, index: number) =>
        (this.styleClasses[item.label.toLowerCase()] = this.value == index),
    );
  }

  protected setValueInternal(value: Temperature) {
    this.value = value;
    this.onModelChange(value);
    this.updateStyleClasses();

    if (this.blotterInstance != null) {
      this.blotterInstance.temperatureSelectionChanged(value);
    }
  }

  writeValue(value: any): void {
    this.value = value;
    this.updateStyleClasses();
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }

  showMenu(): void {
    if (this.splitOptions) {
      this.splitOptions.dropdownClick = true;
      this.splitOptions.overlayVisible = !this.splitOptions.overlayVisible;
    }
  }
}
